// extracted by mini-css-extract-plugin
export default {"trait":"TraitCard_trait__DZamR","type":"TraitCard_type__pKu2v","value":"TraitCard_value__0gAru"};